// AUTO GENERATED FILE - DO NOT EDIT
export default {
  analytics_login_call_type_key: 'call_type',
  analytics_login_call_type_link: 'link',
  analytics_login_completed_page_section: 'Login:Text fields completed',
  analytics_login_empty_fields_page_section: 'Login:Empty fields',
  analytics_login_error_page_section: 'Login:Error',
  analytics_login_event_action_click: 'OnClick',
  analytics_login_event_action_key: 'event_action',
  analytics_login_event_business_label: 'Business',
  analytics_login_event_category: 'Button',
  analytics_login_event_category_key: 'event_category',
  analytics_login_event_label: 'Log in',
  analytics_login_event_label_key: 'event_label',
  analytics_login_event_personal_label: 'Personal',
  analytics_login_journey_type: 'Login',
  analytics_login_journey_type_key: 'journey_type',
  analytics_login_loading_page_section: 'Login:Loading',
  analytics_login_page_name_key: 'page_name',
  analytics_login_page_name_soft_login: 'Soft Login',
  analytics_login_page_name_upfront_login: 'Upfront Login',
  analytics_login_page_section: 'Login',
  analytics_login_page_section_key: 'page_section',
  analytics_login_page_view_event_key: 'page_view',
  analytics_login_screen_type_choose_account: 'Choose account',
  analytics_login_screen_type_edit_accounts_list: 'Edit accounts list',
  analytics_login_screen_type_fixed_line: 'Fixed line',
  analytics_login_screen_type_soft: 'Soft',
  analytics_login_screen_type_upfront: 'Upfront',
  analytics_login_screen_type_verification_code: 'Verification code',
  analytics_login_status_start: 'visitor_login_start',
  analytics_login_ui_interaction_key: 'ui_interaction',
  analytics_login_upfront_button_text_label: 'Log in',
  analytics_login_visitor_login_complete: 'visitor_login_complete',
  analytics_login_visitor_login_status_key: 'visitor_login_status',
  analytics_login_visitor_login_status_logged: 'logged in',
  analytics_login_visitor_login_status_logging: 'logging in',
  analytics_login_visitor_login_type: 'username - password',
  analytics_login_visitor_login_type_key: 'visitor_login_type',
  biometric_login_description: 'Unlock %1$s with fingerprint',
  biometric_login_fallback_button_text: 'Use Password',
  biometric_login_title: 'Unlock with Biometrics',
  biometric_login_use_biometry_type: 'Use %1$s',
  change_language_modal_button: 'Confirm',
  change_language_modal_subtitle: 'Select your preferred language',
  change_language_modal_title: 'Change language',
  choose_account_type_fixed_line_service: 'Fixed line service',
  choose_account_type_mobile_service_title: 'Mobile service',
  choose_account_type_not_registered_with_my_vodafone_label: 'Not registered with My Vodafone?',
  choose_account_type_register_now_button: 'Register now',
  choose_account_type_sign_in_button_text: 'Sign in to a saved account',
  choose_account_type_title: 'Choose your account type',
  confirm_new_password_button: 'Confirm new password',
  confirm_new_password_confirm_password_hint: 'Confirm Password',
  confirm_new_password_error_enter_valid_confirmation_password: 'invalid confirmation password',
  confirm_new_password_error_enter_valid_password: 'invalid password',
  confirm_new_password_password_hint: 'Password',
  confirm_remove_account_account_removed_label: 'Account removed!',
  confirm_remove_account_back_button: 'Back',
  confirm_remove_account_contact_support_button: 'Contact Support',
  confirm_remove_account_remove_account_button: 'Remove Account',
  confirm_remove_account_remove_account_label: 'Remove %1$s\'s account?',
  confirm_remove_account_removing_account_label: 'Removing %1$s\'s account',
  confirm_remove_account_return_to_accounts_button: 'Return to Your Accounts',
  confirm_remove_account_something_went_wrong_label: 'Something went wrong!',
  confirm_remove_account_try_again_button: 'Try again',
  confirm_remove_account_you_could_not_remove_account_label: 'We could not remove %1$s\'s account',
  confirm_remove_account_you_have_successfully_removed_label: 'You have successfully removed %1$s\'s account from the account list.',
  custom_upfront_account_type_business: 'Business',
  custom_upfront_account_type_personal: 'Personal',
  custom_upfront_forgot_your_password_label: 'Forgotten your password',
  custom_upfront_log_in_to: 'Log in to',
  custom_upfront_next: 'Next',
  custom_upfront_password_hint: 'Password',
  custom_upfront_remember_me: 'Remember me',
  custom_upfront_saved_account: 'Sign in to a saved account',
  custom_upfront_username_business_hint: 'User name / identity code',
  custom_upfront_username_business_secondary_placeholder: 'username',
  custom_upfront_username_hint: 'User name / identity code',
  custom_upfront_username_secondary_placeholder: 'username',
  login_change_language_alert_description: 'You need to restart the app for the language to take effect',
  login_change_language_alert_title: 'Changing language',
  login_change_language_label: 'Change language',
  login_more_information_label: 'Read our FAQ',
  login_more_information_text: 'Any questions? %1$s',
  login_progress_text: 'Loading…',
  login_title_text: 'My Vodafone log in',
  register_already_exists_warning_subtitle: 'This account already exists!',
  register_already_exists_warning_text: 'The number %1$s is already linked with an account. You need to input a different number or reset your account details.',
  register_already_exists_warning_title: 'Create account',
  register_confirm_password_hint: 'Confirm Password',
  register_different_account_button: 'Use a different account',
  register_error_enter_valid_confirmation_password: 'invalid confirmation password',
  register_error_enter_valid_password: 'invalid password',
  register_error_enter_valid_phone: 'invalid phone number',
  register_helper_information: 'Here are some friendly tips and helpful advice for the user',
  register_login_text: 'Register',
  register_password_hint: 'Password',
  register_phone_number_hint: 'Phone Number',
  register_registered_with_my_vodafone_label: 'Registered with My Vodafone?',
  register_reset_password_button: 'Reset your password',
  register_use_your_credentials: 'Use your credentials',
  register_verifying_loading_text: 'Verifying…',
  registered_account_edit_dialog_button: 'Return to Sign in',
  registered_account_edit_dialog_hint: 'Removing an account from Your account list does not effect your access. You can still sign in all your registered accounts from the Sign-in page.',
  registered_account_edit_dialog_title: 'All accounts (%1$s)',
  registered_account_edit_your_account_list_label: 'Edit your account list',
  registered_account_log_in_another_account_button: 'Log in to another account',
  registered_account_register_now_label: 'Register now',
  registered_account_sign_in_another_account_button: 'Sign in to another account',
  registered_account_sign_in_label: 'Sign in',
  registered_account_want_to_register_label: 'Want to register a new My Vodafone account?',
  registered_account_your_accounts_label: 'Your accounts (%1$s)',
  reset_password_not_exist_warning_create_account_button: 'Create account',
  reset_password_not_exist_warning_subtitle: 'This account does not exist!',
  reset_password_not_exist_warning_text: 'The number %1$s is not linked with an account. You need to input a different number or create a new account.',
  reset_password_not_exist_warning_title: 'Forgot password',
  reset_password_not_exist_warning_use_different_account_button: 'Use a different account',
  seamless_login_failed: 'Seamless login failed',
  soft_login_add_valid_phone_number: 'Please enter a valid phone number',
  soft_login_error_title: 'An error occurred.',
  soft_login_error_try_again: 'Please try again.',
  soft_login_footer_first_label: 'You’ll only have limited access unless you',
  soft_login_footer_second_label: 'sign in with your username and password',
  soft_login_hint: 'Phone number',
  soft_login_next_label: 'Next',
  upfront_blocked_account_dialog_warning_icon_desc: 'Warning',
  upfront_email_or_phone_number_hint: 'Email or phone number',
  upfront_email_or_phone_number_secondary_placeholder: 'phoneNumber',
  upfront_forgot_your_password_label: 'Forgotten your password',
  upfront_login_access_secure_content_subtitle: 'We need to make sure it is you before you can view secure information or make a purchase',
  upfront_login_access_secure_content_title: 'Access my account',
  upfront_login_biometric_biometric_text: 'Use Biometrics',
  upfront_login_biometric_face_id_text: 'Use FaceID',
  upfront_login_biometric_touch_id_text: 'Use TouchID',
  upfront_login_blocked_warning_subtitle: 'Too many attempts!',
  upfront_login_blocked_warning_text: 'The account %1$s is blocked. You need to reset your account in order to continue or try with a different account.',
  upfront_login_blocked_warning_title: 'Blocked account',
  upfront_login_different_account_login_button: 'Use a different account',
  upfront_login_error_enter_valid_email: 'Please enter a valid email address or phone number',
  upfront_login_error_enter_valid_number: 'Please enter a valid number in format 12345678',
  upfront_login_error_enter_valid_password: 'Please enter a valid password',
  upfront_login_error_message: 'Your email or password is not correct.',
  upfront_login_error_multiple_attempts_remaining: 'You have %1$s attempts remaining. Please try again',
  upfront_login_error_single_attempt_remaining: 'You have %1$s attempt remaining. Please try again',
  upfront_login_error_title: 'Your username or password is not correct',
  upfront_login_error_try_again: 'Please try again.',
  upfront_login_error_try_again_single_attempt: 'Please try again. 1 attempt remaining.',
  upfront_login_footer_sign_with_phone_number: 'Sign in with your phone number',
  upfront_login_helper_information: 'Here are some friendly tips and helpful advice for the user',
  upfront_login_invalid_password: 'Password is not correct',
  upfront_login_or_text: 'or',
  upfront_login_payer_number: 'Payer number',
  upfront_login_reset_account_login_button: 'Reset your account',
  upfront_login_tab_bar_first: 'Mobile services',
  upfront_login_tab_bar_second: 'Fixed line services',
  upfront_login_text: 'Log in',
  upfront_not_registered_with_my_vodafone_label: 'Not registered with My Vodafone?',
  upfront_our_privacy_label: 'Our Privacy',
  upfront_password_hint: 'Password',
  upfront_register_now_label: 'Register now',
  upfront_remember_me_label: 'Remember me',
  verification_change_email_text: 'Change email',
  verification_change_number_text: 'Change mobile number',
  verification_description_receive_sms: 'You should receive an SMS message with a 4 digit code to the number provided within the next 3 minutes',
  verification_enter_code_text: 'Please enter the 4 digit code:',
  verification_error_code_is_not_correct: 'Your code is not correct',
  verification_loading_login_text: 'Logging in…',
  verification_resend_login_code_text: 'Re-send code',
  verification_resend_login_code_text_with_timer: 'Re-send code (%1$s)',
  verification_sent_code_text: 'We’ve sent the verification code to:',
  verification_verifying_login_code_text: 'Verifying…',
  verification_wrong_phone_error_msg: 'An error occurred.'
}
